// VOK site assets served from Supabase Storage (bucket: site-assets)
export const STORAGE_BASE = "https://mepfitcboghhdoinanwe.supabase.co/storage/v1/object/public/site-assets";
export const ASSETS = {
  logoWhite: `${STORAGE_BASE}/vok_wordmark_white.svg`,
  logoNavy: `${STORAGE_BASE}/vok_wordmark_navy.svg`,
  caseMockup: `${STORAGE_BASE}/case_mockup.png`,
  favicon: `${STORAGE_BASE}/favicon_512.png`,
};
